import React from "react";

import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import Index from "./pages/publico/Index";
import RedefinirSenha from "./pages/publico/RedefinirSenha";
import CadastroEmpresa from "./pages/publico/CadastroEmpresa";
import Home from "./pages/empresa/Home";
import Perfil from "./pages/empresa/Perfil";
import Vagas from "./pages/empresa/Vagas";
import NovaVaga from "./pages/empresa/NovaVaga";
import EditarVaga from "./pages/empresa/EditarVaga";
import DetalheVaga from "./pages/empresa/DetalheVaga";
import { getUsuario, isSignedIn } from "./services/security";
import BuscarAlunos from "./pages/empresa/BuscarAlunos";
import AceitarTermo from "./pages/empresa/AceitarTermo";

import LoginAdmin from "./pages/publico/LoginAdmin";
import HomeAdmin from "./pages/admin/Home";
import Empresas from "./pages/admin/Empresas";
import VagasAdmin from "./pages/admin/Vagas";
import IntegracaoSG7 from "./pages/admin/IntegracaoSG7";

import SideBar from "./components/SideBar";
import Footer from "./components/Footer";
import DetalheVagaAdmin from "./pages/admin/DetalheVagaAdmin";

const EmpresaRoute = ({ children, location, ...rest }) => {
  if (isSignedIn("empresa")) {
    const empresa = getUsuario();

    if (!empresa.aceitou_termos) {
      return (
        <Redirect
          to={{
            pathname: "/empresa/aceitar-termos",
            state: { from: location },
          }}
        />
      );
    }

    return (
      <Route {...rest}>
        <SideBar></SideBar>
        {children}
        <Footer />
      </Route>
    );
  } else {
    return (
      <Redirect
        to={{
          pathname: "/",
          state: { from: location },
        }}
      />
    );
  }
};

const TermoEmpresaRoute = ({ children, location, ...rest }) => {
  if (isSignedIn("empresa")) {
    return (
      <Route {...rest}>
        <SideBar></SideBar>
        {children}
        <Footer />
      </Route>
    );
  }
};

const AdminRoute = ({ children, location, ...rest }) => {
  return isSignedIn("admin") ? (
    <Route {...rest}>{children}</Route>
  ) : (
    <Redirect
      to={{
        pathname: "/",
        state: { from: location },
      }}
    />
  );
};

const InitialRoute = ({ children, location, ...rest }) => {
  if (isSignedIn("empresa")) {
    return (
      <Redirect
        to={{
          pathname: "/empresa/home",
          state: { from: location },
        }}
      />
    );
  } else if (isSignedIn("admin")) {
    return (
      <Redirect
        to={{
          pathname: "/admin/home",
          state: { from: location },
        }}
      />
    );
  } else {
    return <Route {...rest}>{children}</Route>;
  }
};

function Routes() {
  return (
    <BrowserRouter>
      <Switch>
        <InitialRoute exact path="/">
          <Index />
          <Footer />
        </InitialRoute>
        <Route exact path="/redefinir-senha">
          <RedefinirSenha />
          <Footer />
        </Route>
        <Route exact path="/admin">
          <LoginAdmin />
          <Footer />
        </Route>
        <Route path="/cadastrar-empresa">
          <CadastroEmpresa />
          <Footer />
        </Route>
        <TermoEmpresaRoute path="/empresa/aceitar-termos">
          <AceitarTermo />
        </TermoEmpresaRoute>
        <EmpresaRoute path="/empresa/home">
          <Home />
        </EmpresaRoute>
        <EmpresaRoute path="/empresa/perfil">
          <Perfil />
        </EmpresaRoute>
        <EmpresaRoute path="/empresa/vagas">
          <Vagas />
        </EmpresaRoute>
        <EmpresaRoute path="/empresa/nova-vaga">
          <NovaVaga />
        </EmpresaRoute>
        <EmpresaRoute path="/empresa/editar-vaga">
          <EditarVaga />
        </EmpresaRoute>
        <EmpresaRoute path="/empresa/detalhe-vaga/:id">
          <DetalheVaga />
        </EmpresaRoute>
        <EmpresaRoute path="/empresa/buscar-alunos">
          <BuscarAlunos />
        </EmpresaRoute>

        <AdminRoute path="/admin/home">
          <HomeAdmin />
        </AdminRoute>
        <AdminRoute path="/admin/empresas">
          <Empresas />
        </AdminRoute>
        <AdminRoute path="/admin/vagas">
          <VagasAdmin />
        </AdminRoute>
        <AdminRoute path="/admin/integracao-sg7">
          <IntegracaoSG7 />
        </AdminRoute>
        <AdminRoute path="/admin/detalhe-vaga/:id">
          <DetalheVagaAdmin />
        </AdminRoute>
      </Switch>
    </BrowserRouter>
  );
}

export default Routes;
